export function toCurrency( value, symbol = '' ){
  let number = value.toFixed(2);
  return symbol + number;
}
